import { FlexColumn, LabeledInput, useLoading } from '@gorila-shared-ui/components';
import { useEffect, useState } from 'react';
import { useFeedback } from '../../hooks/useFeedback';
import { useStyles } from '../../hooks/useStyles';
import { FormActionsRow } from '../shared/FormActionsRow';
import StyledModal from '../shared/StyledModal';
import { cancelJobWithFailedVisit } from '../../services/jobsService';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  jobId?: string;
  onSubmitFinished?: () => void;
};

export function JobFailedVisitModal({ isOpen, onClose, jobId, onSubmitFinished }: Readonly<Props>) {
  const { css } = useStyles();
  const [reason, setReason] = useState('');
  const [onTouched, setOnTouched] = useState(false);
  const { loading, startLoading, stopLoading } = useLoading();
  const { showFailFeedback, showPositiveFeedback } = useFeedback();
  const canSubmit = reason.length > 0;


  useEffect(() => {
    if (isOpen) {
      return clearStates();
    }
  }, [isOpen]);

  const clearStates = () => {
    setReason('');
    setOnTouched(false);
  };

  const onSubmit = async () => {
    if (!jobId || !canSubmit) return;
    const onSuccess = (successMessage: string) => {
      showPositiveFeedback(successMessage);
      clearStates();
      onSubmitFinished?.();
    };
    startLoading();
    const { error } = await cancelJobWithFailedVisit(jobId, reason);
    if (error) {
      showFailFeedback(error || 'Ocurrió un error al registrar la visita fallida.');
    } else {
      onSuccess('Se registro la visita fallida correctamente.');
    }
    stopLoading();
  };

  const onCloseModal = () => {
    clearStates();
    onClose();
  };

  return (
    <StyledModal
      isOpen={isOpen}
      closeable
      onClose={onCloseModal}
      size="auto"
      title={"Registrar visita fallida"}
      content={
        <FlexColumn
          classNames={css({
            justifyContent: 'space-between',
            overflow: 'hidden',
            minWidth: '525px',
          })}
        >
          <FlexColumn
            classNames={css({
              overflow: 'auto',
              height: '100%',
            })}
          >
            <LabeledInput
              label="Razón"
              placeholder="Ingresa el motivo por el cual la visita fallo"
              value={reason}
              onChange={(value) => {
                setReason(value);
              }}
              onBlur={() => setOnTouched(true)}
              error={onTouched && reason.length === 0 && 'La razón es requerida'}
              required
            />
          </FlexColumn>
          <FormActionsRow
            canSubmit={canSubmit}
            submitText='Registrar'
            loading={loading}
            onSubmit={onSubmit}
            onCancel={onCloseModal}
          />
        </FlexColumn>
      }
    />
  );
}
